import { Download, FlaskConical } from "lucide-react";

import { Alert, AlertAction, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { config } from "@/lib/config";

import type { ClaimWithRelations } from "../api/use-claim";
import { usePullClaimRealDocuments } from "../api/use-claim-mutations";
import { isNotImported } from "../lib/open-box";

/** Staging and the PR sandboxes, until the claim's real documents are downloaded (claim puller). */
export function RealDocumentsRibbon({ claim }: { claim: ClaimWithRelations }) {
  const pullRealDocuments = usePullClaimRealDocuments(claim.id);
  if (config.APP_ENV === "production" || !claim.boxFolderId || !isNotImported(claim.boxFolderId)) {
    return null;
  }

  return (
    <Alert variant="info" className="my-4">
      <FlaskConical />
      <AlertTitle>Pièces réelles non téléchargées</AlertTitle>
      <AlertDescription>
        Ce dossier n'affiche que des SPÉCIMEN. Téléchargez ses pièces réelles, marquées SANDBOX / TEST.
      </AlertDescription>
      <AlertAction>
        <Button onClick={() => pullRealDocuments.mutate()} loading={pullRealDocuments.isPending}>
          <Download />
          Télécharger les pièces réelles
        </Button>
      </AlertAction>
    </Alert>
  );
}
